<template>
<div v-show="visible" class="connectedElement" :style="'z-index:'+zDepth+';'">
   
   <Connector :pt1="connector1.pt1" :pt2="connector1.pt2"></Connector>
  <VueDragResizeAndRotate  :active="isActive" dragCancel=".leaflet-grab" :sticks="sticks" :w="width+33" :h="height+110" :resizable="resize" @resizing="resizingLocal"   @dragging="draggingLocal" :dragHandle="dragHandle"  :style="'top:'+pos.y+'px;left:'+pos.x+'px;background:'+dragBG+';'">
        <slot></slot>
        <div v-if="parentNode">parent</div>
        <div style="position:absolute;top:100px; color:#000;z-index:1000"> </div>
  </VueDragResizeAndRotate>
  </div>
</template>

<script>
import Connector from "@/components/Connector.vue"
import VueDragResizeAndRotate from 'vue-drag-resize-and-rotate'
export default {
  components: {
    Connector,
    VueDragResizeAndRotate
  },
  props: {
    isActive:{ default:true},
    width:{ default:200},
    height:{ default:100},
    index:{ default:null},
    dragging:{ default:null},
    resizing:{ default:null},
    parentNode:{ default:null},
    resize:{default:false},
    dragHandle:{type:String, default:null},
    pos:{type: Object,default: function () { return {x:100,y:0} }},
    anchor:{type: Object,default: function () { return {x:0,y:0} }},
    
  },
  data() {
    return {
      self:null,
      mode:null,
      zDepth:1,
      visible:true,
      dx:0,
      dy:0,
      h:300,
      
    };
  },
  mounted(){
    this.self=this
   
  },
  computed: {
    dragBG(){
       if(this.resize){
         return "#fff"
       }else{
         return "transparent"
       }
    },
    sticks(){
      if(this.resize){
        return [ 'tl','tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml', 'ro']
      }
      return []
    },
  
    anchorParent(){
      if(this.parentNode){
        
         return  {x:this.parentNode.dx+this.anchor.x,y:this.parentNode.dy+this.anchor.y}
      }else{
       return  this.anchor
      }
    },
   connector1(){
      return {pt1:this.anchorParent,pt2:{x:this.pos.x+12+this.dx,y:this.pos.y+76+this.dy}}
    },
     
  },
  methods: {
    resizingLocal(params){
      if(this.resizing){
        this.resizing(params,this)
      }
    },
    draggingLocal(params){
      
      this.dx=params.x
      this.dy=params.y
      if(this.dragging){
       // console.log(this._self)
        this.dragging(params,this)
      }
    },
  },
  watch:{
   
    mode(val){
      
      if(val=="hidden"){
        this.visible=false
      }else{
        this.visible=true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.connectedElement{
    position: absolute;
    top: 0px;
    left: 0px;
    z-index:2;
    pointer-events: auto;
}

</style>
